import { twMerge } from "tailwind-merge";

export const ButtonToggleGroup = (
  p: React.ComponentProps<"div"> & {
    "aria-disabled"?: boolean;
  },
) => {
  return (
    <div
      aria-disabled={p["aria-disabled"]}
      className={twMerge(
        // Container (54x27 in spec). We let height/width be controlled by parent.
        // Visuals: subtle background, outline border, focus ring on any inner button focus.
        "group flex items-center gap-1 rounded-lg px-1 border",
        "bg-surface-2 border-outline text-foreground",
        // Disabled state for entire group when marked as disabled
        "aria-disabled:bg-neutral-disabled!",
        // Disabled border color
        "aria-disabled:border-neutral-on-disabled data-[disabled=true]:border-neutral-on-disabled",
        // Also disable pointer events for the whole group when disabled
        "data-[disabled=true]:pointer-events-none aria-disabled:pointer-events-none",
        "focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2",
        p.className,
      )}
    >
      {p.children}
    </div>
  );
};

export const ButtonToggle = (
  p: React.ComponentProps<"button"> & {
    "data-active": boolean;
  },
) => {
  return (
    <button
      {...p}
      className={twMerge(
        // Base
        "inline-flex items-center justify-center rounded-md",
        // Size approximates 21x21 inner chip from spec
        "w-7 h-7",
        // Inactive state text/icon
        "data-[active=false]:text-neutral data-[active=false]:bg-header",
        // Active state chip background and foreground
        "data-[active=true]:bg-neutral-tonal data-[active=true]:text-neutral-on-tonal",
        // Selected (active) layout per spec
        "data-[active=true]:flex data-[active=true]:rounded-md data-[active=true]:p-1",
        // Hover affordance on inactive and active
        "data-[active=false]:hover:bg-surface-3 data-[active=false]:hover:rounded-full data-[active=false]:hover:p-[3px]",
        // Disabled visuals (chained variants; no comma-separated arbitrary variants)
        "disabled:data-[active=false]:bg-neutral-disabled",
        "disabled:data-[active=false]:text-neutral-on-disabled",
        "disabled:data-[active=false]:cursor-not-allowed",
        "disabled:data-[active=false]:pointer-events-none",
        // Selected (active) when disabled should use on-disabled color
        "disabled:data-[active=true]:text-neutral-on-tonal",
        "disabled:data-[active=true]:bg-neutral-on-disabled",
        // Suppress hover when disabled
        "disabled:hover:bg-neutral-disabled disabled:hover:rounded-md disabled:hover:p-1",
        p.className,
      )}
    />
  );
};
